export const COLOR_1 = '#4f46e5'; // indigo-600
export const COLOR_2 = '#3b82f6'; // blue-500
export const COLOR_3 = '#10b981'; // emerald-500
export const COLOR_4 = '#f59e0b'; // amber-500
export const COLOR_5 = '#ef4444'; // red-500
export const COLOR_6 = '#8b5cf6'; // purple-500
export const COLOR_7 = '#06b6d4'; // cyan-500

export const COLOR_1_LIGHT = '#e0e7ff'; // indigo-100
export const COLOR_2_LIGHT = '#dbeafe'; // blue-100
export const COLOR_3_LIGHT = '#d1fae5'; // emerald-100
export const COLOR_4_LIGHT = '#fef3c7'; // amber-100
export const COLOR_5_LIGHT = '#fee2e2'; // red-100
export const COLOR_6_LIGHT = '#f3e8ff'; // purple-100
export const COLOR_7_LIGHT = '#cffafe'; // cyan-100

export const COLORS = [COLOR_1, COLOR_2, COLOR_3, COLOR_4, COLOR_5, COLOR_6, COLOR_7];

export const COLORS_LIGHT = [
  COLOR_1_LIGHT,
  COLOR_2_LIGHT,
  COLOR_3_LIGHT,
  COLOR_4_LIGHT,
  COLOR_5_LIGHT,
  COLOR_6_LIGHT,
  COLOR_7_LIGHT
];
